import { SiteConfigSection } from "@/apidtos";
import { useRootLoaderData } from "@/root";

export const useSiteConfig = () => {
  const { config } = useRootLoaderData();
  return config.Site as SiteConfigSection;
};
